import { TPosition } from '@nettbureau/featured-core';
import { Fragment, ReactElement } from 'react';

export interface RenderPositionProps {
  positions: TPosition[];
  render: (pos: TPosition) => ReactElement | null;
}

export function RenderPosition({ positions, render }: RenderPositionProps) {
  return (
    <Fragment>
      {positions.map((position, index) => {
        return <Fragment key={index}>{render(position)}</Fragment>;
      })}
    </Fragment>
  );
}
